module.exports = __webpack_public_path__ + "img/rightFlip@2x.f90c76a0.png";